import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fw-bold" }
const _hoisted_2 = ["placeholder", "disabled"]
const _hoisted_3 = { class: "text-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createBlock(_component_Field, {
    modelValue: _ctx.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value) = $event)),
    name: _ctx.inputName,
    label: _ctx.t(_ctx.label).toString().toLowerCase(),
    rules: { required: _ctx.disabled ? false : _ctx.required }
  }, {
    default: _withCtx(({ field, errorMessage, meta }) => [
      _createElementVNode("div", {
        class: _normalizeClass(["form-group", !meta.valid ? 'input-error' : ''])
      }, [
        _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.t(_ctx.label)), 1),
        _createElementVNode("input", _mergeProps(field, {
          autocomplete: "false",
          placeholder: _ctx.t(_ctx.placeholder),
          class: "input",
          disabled: _ctx.disabled,
          maxlength: "8",
          type: "text",
          inputmode: "numeric",
          onKeypress: _cache[0] || (_cache[0] = (e) => {
          if (!/[0-9]/.test(e.key)) {
            e.preventDefault()
          }
        })
        }), null, 16, _hoisted_2)
      ], 2),
      _createElementVNode("small", _hoisted_3, _toDisplayString(errorMessage), 1)
    ]),
    _: 1
  }, 8, ["modelValue", "name", "label", "rules"]))
}